import { createEl } from '../../helpers/functions';
const {
  AbortController
} = window;
const storedSearchQueries = {};
class Autocomplete {
  constructor({
    selector = '.search-from',
    // string css selector || form with attrs action & data-suggest
    minLength = 1,
    // min chars for request
    autoFocus = true,
    appendToSelector = '.autocomplete-result',
    classes = '',
    // string with additional css classes
    errorMessages = {
      minLength: 'Please type more then 1 symbols',
      noResults: 'No results'
    },
    // string | object
    listItemTag = 'li',
    topResultsTitle = 'Top Ergebnisse',
    // string
    allResultsTitle = 'All results'
  }) {
    this.$searchForm = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!this.$searchForm) return;
    this.$searchInput = this.$searchForm.querySelector('.js-solr-q') || this.$searchForm.querySelector('input');
    this.$autocompleteResult = this.$searchForm.querySelector('.autocomplete-result');
    this.$autocompleteList = this.$searchForm.querySelector('.autocomplete-list');
    this.action = this.$searchForm.getAttribute('action');
    this.suggest = this.$searchForm.getAttribute('data-suggest');
    this.name = this.$searchInput.getAttribute('name');
    this.topResultsTitle = this.$searchForm.dataset.topResultsTitle || topResultsTitle;
    this.allResultsTitle = this.$searchForm.dataset.allResultsTitle || allResultsTitle;
    this.minLength = minLength;
    this.autoFocus = autoFocus;
    this.appendToSelector = appendToSelector;
    this.classes = classes;
    this.valueBeforeOpen = '';
    this.errorMessages = {
      minLength: this.$searchForm.dataset.errorMinLength || errorMessages.minLength,
      noResults: this.$searchForm.dataset.errorNoResult || errorMessages.noResults
    };
    this.listItemTag = listItemTag;
    this.suggestRequestController = new AbortController();
    this.init();
  }
  init() {
    this.renderWrapper(this.$searchForm.querySelector('.search-field-wrapper') || this.$searchInput);
    this.addHandlers();

    // Add 'filled' class if input has value on page load
    this.$searchInput.classList.toggle('filled', !!this.$searchInput.value.length);
  }
  addHandlers() {
    this.$searchInput.addEventListener('input', () => {
      this.changeHandler();
    });
    this.$autocomplete.addEventListener('focusout', () => this.blurHandler());
    this.$autocomplete.addEventListener('focusin', () => this.focusHandler());
    this.$autocompleteResult.addEventListener('mouseleave', () => {
      this.removeSelectedClass();
    });
    this.$searchInput.addEventListener('keydown', e => {
      this.keyDownHandler(e);
    });
  }
  renderWrapper($el) {
    this.$autocomplete = createEl('div', {
      class: `autocomplete ${typeof this.classes === 'string' ? this.classes : ''}`,
      tabindex: '1'
    });
    if (this.appendToSelector === null) {
      this.$autocompleteResult = createEl('div', {
        class: 'autocomplete-result'
      });
      this.$autocompleteList = createEl('ul', {
        class: 'autocomplete-list'
      });
      this.$autocompleteResult.append(this.$autocompleteList);
    } else {
      // Ensure the selector is scoped to this.$searchForm
      this.$autocompleteResult = this.$searchForm.querySelector(this.appendToSelector);
      if (!this.$autocompleteResult) {
        // Fallback: Create a default autocomplete result and list
        this.$autocompleteResult = createEl('div', {
          class: 'autocomplete-result'
        });
        this.$autocompleteList = createEl('ul', {
          class: 'autocomplete-list'
        });
        this.$autocompleteResult.append(this.$autocompleteList);
      } else {
        // Initialize $autocompleteList if appendToSelector is found
        this.$autocompleteList = this.$autocompleteResult.querySelector('.autocomplete-list');
        if (!this.$autocompleteList) {
          this.$autocompleteList = createEl('ul', {
            class: 'autocomplete-list'
          });
          this.$autocompleteResult.append(this.$autocompleteList);
        }
      }
    }
    $el.parentNode.insertBefore(this.$autocomplete, $el);
    this.$autocomplete.appendChild($el);
    if (this.appendToSelector === null) this.$autocomplete.appendChild(this.$autocompleteResult);
    this.close();
  }
  changeHandler() {
    this.abortSuggestRequest();
    const {
      value
    } = this.$searchInput;
    this.$searchInput.classList.toggle('filled', !!value.length);
    if (value.length >= this.minLength) {
      this.suggestRequest(value);
    } else {
      this.error(this.errorMessages.minLength);
    }
  }
  keyDownHandler(e) {
    if (document.activeElement.classList.contains('js-solr-q')) {
      const $selectedElement = this.$autocompleteList.querySelector('.selected');
      const $a = $selectedElement && $selectedElement.querySelector('a');
      if (!this.$autocompleteResult.classList.contains('show')) return;
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if ($selectedElement && $selectedElement.previousElementSibling) {
          const $prevEl = $selectedElement.previousElementSibling.classList.contains('autocomplete-title') ? $selectedElement.previousElementSibling.previousElementSibling : $selectedElement.previousElementSibling;
          this.setSelectedEl($prevEl, $prevEl.dataset.value);
        } else {
          this.$searchInput.value = this.valueBeforeOpen;
          this.removeSelectedClass();
        }
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if ($selectedElement && $selectedElement.nextElementSibling) {
          const $nextEl = $selectedElement.nextElementSibling.classList.contains('autocomplete-title') ? $selectedElement.nextElementSibling.nextElementSibling : $selectedElement.nextElementSibling;
          this.setSelectedEl($nextEl, $nextEl.dataset.value);
        } else if (!$selectedElement) {
          const $firstLi = this.$autocompleteList.querySelector('li');
          this.setSelectedEl($firstLi, $firstLi.dataset.value);
        }
      }
      if (e.key === 'Enter' && $a) {
        e.preventDefault();
        if ($a) $a.click();
      }
    }
  }
  abortSuggestRequest() {
    this.suggestRequestController.abort();
    this.suggestRequestController = new AbortController();
    this.$autocompleteList.innerHTML = '';
  }
  suggestRequest(value) {
    const storedResponseDataStr = storedSearchQueries[value];
    if (storedResponseDataStr) {
      this.suggestRequestSuccess(storedResponseDataStr);
    } else {
      fetch(`${this.suggest}&tx_solr%5BqueryString%5D=${value}`, {
        signal: this.suggestRequestController.signal
      }).then(response => response.text()).then(dataStr => {
        this.suggestRequestSuccess(dataStr);
        storedSearchQueries[value] = dataStr;
      }).catch(() => {});
    }
  }
  suggestRequestSuccess(dataStr) {
    const {
      suggestions,
      suggestion,
      documents
    } = JSON.parse(dataStr);
    if (suggestions && suggestions) {
      this.$autocompleteList.innerHTML = '';
      this.renderList({
        suggestions: suggestions ? Object.keys(suggestions) : [],
        suggestion: suggestion || '',
        pages: documents || []
      });
    } else {
      this.error(this.errorMessages.noResults);
    }
  }
  renderList({
    suggestions,
    suggestion,
    pages
  }) {
    const listFragment = document.createDocumentFragment();
    const pagesFragment = document.createDocumentFragment();
    suggestions.slice(0, 3).forEach(item => {
      const $li = createEl(this.listItemTag, {
        class: 'autocomplete-item',
        tabindex: '0',
        'data-value': item
      }, item.replace(suggestion, `<b>${suggestion}</b>`));
      $li.addEventListener('click', () => this.chooseHandler($li));
      $li.addEventListener('mouseenter', () => this.setSelectedEl($li, null));
      listFragment.appendChild($li);
    });
    pages.forEach(page => {
      const {
        link,
        title
      } = page;
      const aHtml = `<a href="${link}">${title}</a>`;
      const $li = createEl(this.listItemTag, {
        class: 'autocomplete-item'
      }, aHtml);
      pagesFragment.appendChild($li);
    });
    const allResultsButton = createEl('button', {
      class: 'link link-arrow autocomplete-submit',
      type: 'submit'
    }, this.allResultsTitle);
    allResultsButton.addEventListener('click', () => {
      this.submitHandler();
    });
    this.$autocompleteList.append(listFragment, pagesFragment, allResultsButton);
    if (document.activeElement === this.$searchInput) {
      this.open();
    }
  }
  error(content = 'No result', errorClass = 'autocomplete-result__empty') {
    const $error = document.createElement(this.listItemTag);
    $error.classList.add(errorClass, 'autocomplete-error');
    $error.innerHTML = content;
    this.$autocompleteList.innerHTML = '';
    this.$autocompleteList.appendChild($error);
    this.open();
  }
  chooseHandler($el) {
    this.$searchInput.value = $el.innerText;
    this.close();
    this.submitHandler();
  }
  setSelectedEl($el, value) {
    this.removeSelectedClass();
    $el.classList.add('selected');
    if (value) {
      this.$searchInput.value = value;
    }
  }
  removeSelectedClass() {
    this.$autocompleteList.querySelectorAll('.selected').forEach($s => $s.classList.remove('selected'));
  }
  submitHandler() {
    const $form = this.$searchForm.closest('form');
    if (!$form) return;
    $form.classList.add('loading');
    $form.submit();
  }
  blurHandler() {
    this.close();
    this.$autocomplete.classList.remove('show');
  }
  focusHandler() {
    this.open();
  }
  close() {
    this.$autocompleteResult.classList.remove('show');
    this.removeSelectedClass();
  }
  open() {
    if (this.$autocompleteList.querySelectorAll(this.listItemTag).length) {
      this.$autocompleteResult.classList.add('show');
      this.valueBeforeOpen = this.$searchInput.value;
    }
  }
  reset() {
    // Clear the input field
    this.$searchInput.value = '';

    // Close the autocomplete dropdown
    this.close();

    // Clear the autocomplete list
    if (this.$autocompleteList) {
      this.$autocompleteList.innerHTML = '';
    }

    // Reset any internal state if necessary
    this.valueBeforeOpen = '';
    this.$searchInput.classList.remove('filled');
  }
}
export default Autocomplete;